<template>
  <div>
    <logged-in-header />
    <store-prices-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import storePricesPanel from "../components/store-prices/StorePricesPanel";

export default {
  components: { loggedInHeader, storePricesPanel }
};
</script>
